module.exports = __webpack_public_path__ + "static/media/i18n.a7168344.png";